import { rangeColor } from '../../../constants/scoreScale';

const percentile = (sorted, p) => {
  if (!sorted.length) return 0;
  const index = Math.min(sorted.length - 1, Math.max(0, Math.round((sorted.length - 1) * p)));
  return sorted[index];
};

/**
 * Recolour road-condition segments with the shared workbook scale:
 * low RMS (smooth surface) is green, high RMS (critical) is red.
 * The 5th–95th percentile range keeps a few outliers from flattening the scale.
 * Segments without an RMS value keep the colour shipped with the data.
 */
export function colorRmsSegments(geojson) {
  const features = geojson?.features || [];
  const values = features
    .map((feature) => Number(feature?.properties?.rms_XYZ))
    .filter(Number.isFinite)
    .sort((a, b) => a - b);
  if (!values.length) return geojson;

  const min = percentile(values, 0.05);
  const max = percentile(values, 0.95);

  return {
    ...geojson,
    features: features.map((feature) => {
      const rms = Number(feature?.properties?.rms_XYZ);
      if (!Number.isFinite(rms)) return feature;
      return {
        ...feature,
        properties: {
          ...feature.properties,
          color: rangeColor(Math.min(max, Math.max(min, rms)), min, max, { reverse: true }),
        },
      };
    }),
  };
}
